const RANGE_MIN_KEYS = ['min_passage_width', 'min_passage_height', 'min_overall_width', 'min_overall_height'];
const RANGE_MAX_KEYS = ['max_passage_width', 'max_passage_height', 'max_overall_width', 'max_overall_height'];

const normalizeId = (v: any): { opening_areo: string; frame_sides_areo: number } => ({
    opening_areo: v.opening_areo,
    frame_sides_areo: Number(v.frame_sides_areo),
});

const versionKey = (v: any): string => {
    const id = normalizeId(v);
    return `${id.opening_areo}__${id.frame_sides_areo}`;
};

export function sameVersion(a: any, b: any): boolean {
    const x = normalizeId(a);
    const y = normalizeId(b);
    return x.opening_areo === y.opening_areo && x.frame_sides_areo === y.frame_sides_areo;
}

export function dedupeProductVersions(productVersions: any[]): any[] {
    const map = new Map();

    (productVersions || []).forEach((v) => {
        const key = versionKey(v);

        if (!map.has(key)) {
            const base = { opening_areo: v.opening_areo, frame_sides_areo: v.frame_sides_areo };
            [...RANGE_MIN_KEYS, ...RANGE_MAX_KEYS].forEach((k) => { base[k] = v[k]; });
            map.set(key, base);
            return;
        }

        const acc = map.get(key);
        RANGE_MIN_KEYS.forEach((k) => { acc[k] = Math.min(acc[k], v[k]); });
        RANGE_MAX_KEYS.forEach((k) => { acc[k] = Math.max(acc[k], v[k]); });
    });

    return [...map.values()];
}

export function availableCommands(productVersions: any[], openingAreo: string, frameSides: number | string, measures: any = null): any[] {
    let groups = (productVersions || []).filter(
        (v) => sameVersion(v, { opening_areo: openingAreo, frame_sides_areo: frameSides })
    );

    if (measures && measures.width != null && measures.height != null && measures.measureType) {
        const width = Number(measures.width);
        const height = Number(measures.height);
        const type = measures.measureType;

        groups = groups.filter((v) =>
            width >= v[`min_${type}_width`] && width <= v[`max_${type}_width`]
            && height >= v[`min_${type}_height`] && height <= v[`max_${type}_height`]
        );
    }

    return groups;
}
